import { gql } from '@apollo/client';
import { PageFields } from '../fragments';

const GET_CURRENT_PAGE = gql`
  query GetCurrentPage($id: String!, $type: String!) {
    currentPage(id: $id, type: $type) {
      ...PageFields
    }
  }
  ${PageFields}
`;

export { GET_CURRENT_PAGE };
